import { atom, useAtomValue, useSetAtom } from "jotai";
import { DrawerSize } from "rizzui";

export type DrawerPlacements = "left" | "right" | "top" | "bottom";

type DrawerTypes = {
    view: React.ReactNode;
    isOpen: boolean;
    placement?: DrawerPlacements;
    containerClassName?: string;
    size?: DrawerSize;
};

const drawerAtom = atom<DrawerTypes>({
    isOpen: false,
    view: null,
    placement: "right",
    containerClassName: "",
    size: undefined,
});

export function useDrawer() {
    const state = useAtomValue(drawerAtom);
    const setState = useSetAtom(drawerAtom);

    const openDrawer = ({
        view,
        placement,
        containerClassName,
        size = "lg",
    }: {
        view: React.ReactNode;
        placement: DrawerPlacements;
        containerClassName?: string;
        size?: DrawerSize;
    }) => {
        setState({
            ...state,
            isOpen: true,
            view,
            placement,
            containerClassName,
            size,
        });
    };

    const closeDrawer = () => {
        setState({
            ...state,
            isOpen: false,
        });
    };

    return {
        ...state,
        openDrawer,
        closeDrawer,
    };
}
